import z from "zod";
import { requiredId, requiredText } from "../lib/schemas";
//Para GET o DELETE por el Id que se pasa por Param
export const categoryIdParamSchema = z.object({
    categoryId: requiredId,
});
//Para respuesta del GET por id de la categoria
export const getCategoryOutputSchema = z.object({
    id: requiredId,
    name: requiredText,
});
//Para insert de la categoria por id
export const createCategoryInputSchema = z.object({
    name: requiredText,
});
export const updateCategoryInputSchema = z.object({
    name: requiredText,
});
